export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, user-scalable=yes"},{"charset":"utf-8"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"manifest","href":"/site.webmanifest"},{"rel":"preconnect","href":"https://mein.clickskeks.at/"},{"rel":"preconnect","href":"https://integrations.etrusted.com/"},{"rel":"preconnect","href":"https://pubfiles.zentek.dev"}],"style":[],"script":[{"src":"https://mein.clickskeks.at/app.js?apiKey=fb10d41d33155a7355d34e5c3207063c4a10d38d8da951f3&amp;domain=6492ddced4abd15a5b34e66e&amp;lang=de_DE","referrerpolicy":"origin","defer":true,"fetchpriority":"high"},{"src":"https://integrations.etrusted.com/applications/widget.js/v2","referrerpolicy":"origin","async":true,"type":"application/javascript"},{"innerHTML":"// var et_pagename = \"\";\n            // var et_areas = \"\";\n            // var et_tval = 0;\n            // var et_tsale = 0;\n            // var et_tonr = \"\";\n            // var et_basket = \"\";"},{"id":"_etLoader","src":"//code.etracker.com/code/e.js","async":true,"data-block-cookies":"true","data-secure-code":"4aKM59"}],"noscript":[],"charset":"utf-8","htmlAttrs":{"lang":"de"},"viewport":"width=device-width, initial-scale=1, user-scalable=yes","title":"containerdienst.de"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = false

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false